import i18n from '@/i18n/i18n'
import { PermissionService } from '@/services/admin/PermissionService'
import { errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const state = {
  permissions: [],
  permission: {},
  meta: null
}

export const mutations = {
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions.data
    state.meta = permissions.meta
  },
  SET_PERMISSION(state, permission) {
    state.permission = permission
  },
  ADD_PERMISSION(state, permission) {
    state.permissions.push(permission)
  },
  DELETE_PERMISSION(state, permissionToRemove) {
    state.permissions = state.permissions.filter(permission => {
      return permission.id !== permissionToRemove.id
    })
  }
}

export const actions = {
  getPermissions({ commit }) {
    return new Promise(resolve => {
      let permissionService = new PermissionService({ limit: 15 })
      permissionService.getPermissions().then(response => {
        commit('SET_PERMISSIONS', response)
        resolve(response.data)
      })
    })
  },
  getPermission({ commit }, id) {
    return new Promise(resolve => {
      let permissionService = new PermissionService()
      permissionService.getPermission(id).then(response => {
        commit('SET_PERMISSION', response.data)
        resolve(response.data)
      })
    })
  },
  createPermission({ commit, dispatch }, permission) {
    return new Promise(resolve => {
      let permissionService = new PermissionService()
      permissionService
        .createPermission(permission)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.permission.create_permission_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          commit('ADD_PERMISSION', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.permission.create_permission_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
        })
    })
  },
  updatePermission({ state, dispatch }, permission) {
    return new Promise(resolve => {
      let permissionService = new PermissionService()
      permissionService.updatePermission(state.permission.id, permission).then(response => {
        const notification = {
          type: 'success',
          message: t('store.admin.permission.update_permission_success')
        }
        dispatch('notification/add', notification, {
          root: true
        })
        resolve(response.data)
      })
    })
  },
  destroyPermission({ commit, dispatch }, params) {
    return new Promise(resolve => {
      let permissionService = new PermissionService()
      permissionService.destroyPermission(params.id).then(response => {
        commit('DELETE_PERMISSION', params)
        const notification = {
          type: 'warning',
          message: t('store.admin.permission.destroy_permission_success')
        }
        dispatch('notification/add', notification, {
          root: true
        })
        resolve(response.data)
      })
    })
  }
}
